import { useCallback, useReducer } from 'react'
import effects from 'app/effects/effects'
import { isNil } from 'ramda'

export const ActionType = {
  START_LOADING: 'START_LOADING',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_ERROR: 'FETCH_ERROR',
  SET_COUNTRIES: 'SET_COUNTRIES',
  SET_LOADING: 'SET_LOADING',
}

const initialState = {
  subscriber: undefined,
  isLoading: false,
  isCountryLoading: true,
  error: undefined,
  countries: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.START_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case ActionType.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        subscriber: action.payload.subscriber,
        error: undefined,
      }
    case ActionType.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        subscriber: undefined,
        error: action.payload,
      }

    case ActionType.SET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
        isCountryLoading: false,
      }

    case ActionType.SET_LOADING:
      return {
        ...state,
        isLoading: true,
      }

    default:
      return state
  }
}

export default function useSubscriberDetail() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const getSubscriber = (subscriberId) => {
    effects.apis
      .getSubscriberByIdV2({ subscriberId })
      .then((response) => {
        dispatch({
          type: ActionType.FETCH_SUCCESS,
          payload: { subscriber: response },
        })
      })
      .catch((error) => {
        dispatch({ type: ActionType.FETCH_ERROR, payload: { error } })
      })
  }

  const onFetchSubscriberDetail = useCallback((subscriberId) => {
    dispatch({ type: ActionType.START_LOADING })
    if (isNil(state.subscriber)) {
      getSubscriber(subscriberId)
    }
  }, [])

  const refetchData = (subscriberId) => getSubscriber(subscriberId)

  const getCountries = () => {
    effects.apis.getCountries().then((response) => {
      dispatch({ type: ActionType.SET_COUNTRIES, payload: response.data })
    })
  }

  const onLoading = () => {
    dispatch({ type: ActionType.SET_LOADING })
  }

  return {
    state,
    onFetchSubscriberDetail,
    refetchData,
    getCountries,
    onLoading,
  }
}
